import Swiper from 'swiper/dist/js/swiper.min.js';


export default {
    init(el) {
        let options = $(el).data('options');


        let navigation = {};
        let prev = $(el).find('.swiper-button-prev');
        let next = $(el).find('.swiper-button-next')
        if ( prev.length && next.length ) {
            navigation = {
                navigation: {
                    nextEl: next[0],
                    prevEl: prev[0]
                }
            }
        }
        let mergedOptions = {...options, ...navigation};
        let slider = new Swiper($(el).find('.swiper-container'), mergedOptions);
        console.log(el, mergedOptions);
    }
}

// import Vue from 'vue';
//     export default new Vue({
//         el: '.swiper-component',
//         props: ['options', 'type'],
//         data() {
//           return {
//               slider: null,
//               defaults: {
//                   navigation: {
//                       nextEl: this.$refs.next,
//                       prevEl: this.$refs.prev,
//                   }
//               }
//           }
//         },
//         mounted() {
//             let navigation = {
//                 navigation: {
//                     nextEl: this.$refs.next,
//                     prevEl: this.$refs.prev,
//                 }
//             }
//             let mergedOptions = {...JSON.parse(this.options), ...navigation};
//             this.slider = new Swiper(this.$refs.slider,
//                mergedOptions
//             );
//         }
//     })
